import api from './api'
import type { ApiResponse } from '@/types/api.types'
import type {
  PointTransaction,
  PointConversion,
  Withdrawal,
  Deposit,
  UserStreak,
  UserLevel,
  ConversionRate
} from '@/types/points.types'

class PointsService {
  async getPointHistory(userId?: number): Promise<PointTransaction[]> {
    const params = userId ? { user_id: userId } : {}
    const response = await api.get<ApiResponse<PointTransaction[]>>('/api/v1/profile/point_history', { params })
    return response.data.data || []
  }

  async getUserPoints(userId?: number): Promise<{ points: number; total_gained_points?: number; total_money_amount?: number; money_amount?: number }> {
    const params = userId ? { user_id: userId } : {}
    const response = await api.get<ApiResponse<{ points: number; total_gained_points?: number; total_money_amount?: number; money_amount?: number }>>('/api/v1/profile/user_points', { params })
    const d = response.data.data
    return {
      points: d?.points ?? 0,
      total_gained_points: d?.total_gained_points ?? 0,
      total_money_amount: d?.total_money_amount ?? 0,
      money_amount: d?.money_amount ?? 0
    }
  }

  async convertPoints(points: number): Promise<PointConversion> {
    const response = await api.post<ApiResponse<PointConversion>>('/api/v1/profile/convert_points', { points })
    return response.data.data!
  }

  async getConversionHistory(): Promise<PointConversion[]> {
    const response = await api.get<ApiResponse<PointConversion[]>>('/api/v1/profile/point_conversions')
    return response.data.data || []
  }

  async getConversionRate(): Promise<ConversionRate> {
    const response = await api.get<ApiResponse<ConversionRate>>('/api/v1/profile/conversion_rate')
    return response.data.data!
  }

  async requestWithdrawal(amount: number, bankDetails: string, notes?: string): Promise<Withdrawal> {
    const response = await api.post<ApiResponse<Withdrawal>>('/api/v1/profile/submit_withdrawal', {
      amount,
      bank_details: bankDetails,
      notes
    })
    return response.data.data!
  }

  async getWithdrawals(): Promise<Withdrawal[]> {
    const response = await api.get<ApiResponse<Withdrawal[]>>('/api/v1/profile/all_withdrawals')
    return response.data.data || []
  }

  async getDeposits(): Promise<Deposit[]> {
    const response = await api.get<ApiResponse<Deposit[]>>('/api/v1/profile/all_deposits')
    return response.data.data || []
  }

  async getUserLevel(userId?: number): Promise<UserLevel> {
    const params = userId ? { user_id: userId } : {}
    const response = await api.get<ApiResponse<UserLevel>>('/api/v1/profile/user_level', { params })
    return response.data.data!
  }

  async getStreakInfo(userId?: number): Promise<UserStreak> {
    const params = userId ? { user_id: userId } : {}
    const response = await api.get<ApiResponse<UserStreak>>('/api/v1/profile/streak_info', { params })
    return response.data.data!
  }
}

export default new PointsService()
